import { useState, useEffect } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const testimonials = [
  {
    name: 'Carlos Eduardo Silva',
    position: 'CEO',
    company: 'TechVision Solutions',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20executive%20male%20ceo%20portrait%20in%20modern%20office%20clean%20simple%20background%20corporate%20professional%20headshot%20confident%20business%20leader&width=100&height=100&seq=test1&orientation=squarish',
    comment: 'A Persona Pro revolucionou nosso processo de recrutamento. Em apenas 3 meses, conseguimos montar uma equipe de alta performance que elevou nossos resultados em 40%. O profissionalismo e a dedicação da equipe são incomparáveis.',
    rating: 5
  },
  {
    name: 'Mariana Costa',
    position: 'Diretora de RH',
    company: 'Grupo Empresarial Horizonte',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20hr%20director%20portrait%20in%20modern%20office%20clean%20simple%20background%20corporate%20professional%20headshot%20confident%20female%20executive&width=100&height=100&seq=test2&orientation=squarish',
    comment: 'Trabalhar com a Persona Pro foi transformador para nossa empresa. A consultoria em gestão de pessoas nos ajudou a estruturar processos que não tínhamos e a otimizar os existentes. O retorno sobre o investimento foi visível em poucos meses.',
    rating: 5
  },
  {
    name: 'Roberto Almeida',
    position: 'Gerente Geral',
    company: 'Indústrias Almeida & Cia',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20manager%20male%20portrait%20in%20modern%20office%20clean%20simple%20background%20corporate%20professional%20headshot%20experienced%20business%20professional&width=100&height=100&seq=test3&orientation=squarish',
    comment: 'Os programas de treinamento desenvolvidos pela Persona Pro superaram nossas expectativas. Nossa equipe está mais engajada, produtiva e alinhada com os objetivos da empresa. A metodologia aplicada é moderna e eficaz.',
    rating: 5
  },
  {
    name: 'Juliana Ferreira',
    position: 'Fundadora',
    company: 'StartUp Inovação Digital',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20startup%20founder%20portrait%20in%20modern%20office%20clean%20simple%20background%20corporate%20professional%20headshot%20young%20entrepreneur&width=100&height=100&seq=test4&orientation=squarish',
    comment: 'Como startup em crescimento acelerado, precisávamos de um parceiro que entendesse nossas necessidades específicas. A Persona Pro não só entendeu como nos ajudou a construir uma cultura organizacional sólida desde o início.',
    rating: 5
  },
  {
    name: 'Fernando Santos',
    position: 'Diretor Comercial',
    company: 'Comercial Santos & Filhos',
    image: 'https://readdy.ai/api/search-image?query=professional%20business%20executive%20male%20commercial%20director%20portrait%20in%20modern%20office%20clean%20simple%20background%20corporate%20professional%20headshot%20senior%20business%20leader&width=100&height=100&seq=test5&orientation=squarish',
    comment: 'O serviço de headhunting da Persona Pro é simplesmente excepcional. Conseguiram encontrar profissionais de altíssimo nível para posições estratégicas em nossa empresa. O processo foi ágil, discreto e muito profissional.',
    rating: 5
  }
];

export default function Testimonials() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const { ref: sectionRef, isVisible: sectionVisible } = useScrollAnimation<HTMLElement>({ threshold: 0.2 });

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goToTestimonial = (index: number) => {
    setCurrentTestimonial(index);
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="comentarios" className="py-28 bg-gradient-to-b from-white via-[#FFFDF5] to-white relative overflow-hidden" ref={sectionRef}>
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#D4AF37]/3 rounded-full blur-3xl"></div>
      </div>
      
      <div className="w-full px-6 relative z-10">
        <div className="w-full">
          {/* Header */}
          <div className={`text-center mb-20 transition-all duration-1000 ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'}`}>
            <span className="inline-block px-5 py-2 bg-[#D4AF37]/10 text-[#B8941F] rounded-full text-sm font-semibold mb-6 tracking-wide">
              DEPOIMENTOS
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-5">
              O Que Dizem Nossos <span className="text-[#D4AF37]">Clientes</span>
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Histórias reais de empresas que transformaram sua gestão de pessoas com a Persona Pro
            </p>
          </div>

          {/* Testimonial Card */}
          <div className={`relative transition-all duration-1000 delay-300 ${sectionVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <div className="flex items-center justify-center gap-6">
              {/* Previous Button */}
              <button 
                onClick={prevTestimonial}
                className="hidden md:flex w-14 h-14 items-center justify-center bg-white rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer border border-gray-100 group flex-shrink-0"
                aria-label="Depoimento anterior"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-400 group-hover:text-[#D4AF37] transition-colors"></i>
              </button>

              {/* Card Container */}
              <div className="relative w-full max-w-4xl overflow-hidden">
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className={`transition-all duration-700 ${index === currentTestimonial ? 'opacity-100 translate-x-0' : 'opacity-0 absolute inset-0 translate-x-full pointer-events-none'}`}
                  >
                    <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100 relative">
                      {/* Quote Icon */}
                      <div className="absolute -top-6 left-10 w-12 h-12 bg-[#D4AF37] rounded-2xl flex items-center justify-center shadow-lg">
                        <i className="ri-double-quotes-l text-2xl text-white"></i>
                      </div>

                      <div className="flex flex-col md:flex-row gap-8 items-center">
                        {/* Avatar Section */}
                        <div className="flex-shrink-0 text-center">
                          <div className="relative inline-block">
                            <div className="w-28 h-28 rounded-full overflow-hidden ring-4 ring-[#D4AF37]/20 ring-offset-4">
                              <img 
                                src={item.image}
                                alt={item.name}
                                className="w-full h-full object-cover"
                              />
                            </div>
                            <div className="absolute -bottom-2 -right-2 w-8 h-8 bg-[#D4AF37] rounded-full flex items-center justify-center">
                              <i className="ri-check-line text-white text-sm"></i>
                            </div>
                          </div>
                          <div className="mt-5">
                            <div className="font-bold text-gray-900 text-lg">{item.name}</div>
                            <div className="text-gray-500 text-sm">{item.position}</div>
                            <div className="text-[#D4AF37] font-semibold text-sm mt-1">{item.company}</div>
                          </div>
                        </div>

                        {/* Content Section */}
                        <div className="flex-1">
                          {/* Stars */}
                          <div className="flex items-center gap-1 mb-5 justify-center md:justify-start">
                            {[...Array(item.rating)].map((_, i) => (
                              <i key={i} className="ri-star-fill text-xl text-[#D4AF37]"></i>
                            ))}
                          </div>
                          
                          {/* Comment */}
                          <p className="text-gray-700 text-lg md:text-xl leading-relaxed text-center md:text-left">
                            "{item.comment}"
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Next Button */}
              <button 
                onClick={nextTestimonial}
                className="hidden md:flex w-14 h-14 items-center justify-center bg-white rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110 cursor-pointer border border-gray-100 group flex-shrink-0"
                aria-label="Próximo depoimento"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-400 group-hover:text-[#D4AF37] transition-colors"></i>
              </button>
            </div>

            {/* Mobile Navigation Buttons */}
            <div className="flex md:hidden justify-center gap-4 mt-6">
              <button 
                onClick={prevTestimonial}
                className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg cursor-pointer border border-gray-100"
                aria-label="Depoimento anterior"
              >
                <i className="ri-arrow-left-s-line text-xl text-gray-600"></i>
              </button>
              <button 
                onClick={nextTestimonial}
                className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg cursor-pointer border border-gray-100"
                aria-label="Próximo depoimento"
              >
                <i className="ri-arrow-right-s-line text-xl text-gray-600"></i>
              </button>
            </div>
          </div>

          {/* Pagination Dots */}
          <div className={`flex justify-center items-center gap-3 mt-10 transition-all duration-1000 delay-500 ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToTestimonial(index)}
                className={`h-2.5 rounded-full transition-all cursor-pointer ${index === currentTestimonial ? 'bg-[#D4AF37] w-10' : 'bg-gray-300 w-2.5 hover:bg-[#D4AF37]/50'}`}
                aria-label={`Ir para depoimento ${index + 1}`}
              />
            ))}
          </div>

          {/* Trust Badge */}
          <div className={`mt-16 text-center transition-all duration-1000 delay-700 ${sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
            <div className="inline-flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-md border border-gray-100">
              <div className="flex -space-x-2">
                {testimonials.slice(0, 4).map((item, index) => (
                  <div key={index} className="w-8 h-8 rounded-full overflow-hidden border-2 border-white">
                    <img src={item.image} alt="" className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              <div className="text-sm text-gray-600">
                <span className="font-bold text-[#D4AF37]">+500</span> empresas confiam em nós
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
